@if (noDataToDisplay()) {
  <div class="invalid-data-text">{{ 'charts.noChartData' | translate }}</div>
} @else {
  @if (chartOptions()) {
    <div class="chart-container">
      @let options = chartOptions();
      <div class="pie-chart--plot">
        <apx-chart
          [series]="options.series"
          [labels]="options.labels"
          [colors]="options.colors"
          [chart]="options.chart"
          [plotOptions]="options.plotOptions"
          [dataLabels]="options.dataLabels"
          [stroke]="options.stroke"
          [legend]="options.legend"
          [states]="options.states"
          [tooltip]="options.tooltip"
        />
      </div>
      <ul class="pie-chart--legend" [style.color]="colors().text">
        @for (item of legendItems(); track $index) {
          <li class="pie-chart--legend-item">
            <span class="pie-chart--legend-marker" [style.background-color]="item.color"></span>
            {{ item.name }}
          </li>
        }
      </ul>
    </div>
  }
}
